import ResetPassword from "@features/auth/resetPassword/ResetPassword";
import BackToLogin from "@features/common/backToLogin/BackToLogin";

const ResetPasswordPage: React.FC = () => {
  const params = new URLSearchParams(location.search);
  const emailParams = params.get("email") ?? "";

  return (
    <>
 
      <BackToLogin />
      <ResetPassword email={emailParams} />
    </>
  );
};

export default ResetPasswordPage;
